type SortOptionsByLabelOptions = {
  locale?: string;
  isCaseInsensitive?: boolean;
};

type OptionWithLabel = {
  label: string;
};

export const sortOptionsByLabel = <TOption extends OptionWithLabel>(
  options: TOption[],
  sortOptions: SortOptionsByLabelOptions = {}
): TOption[] => {
  const { locale, isCaseInsensitive = true } = sortOptions;

  return [...options].sort((left, right) =>
    left.label.localeCompare(right.label, locale, {
      sensitivity: isCaseInsensitive ? "base" : "variant",
    })
  );
};
